var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "e4ed48a466407c5962d5e9394c5cc005.png",
    width: 20,
    height: 20
});